var SECOMAPP = SECOMAPP || {};
SECOMAPP.ca = SECOMAPP.ca || {};

!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if(i=e({path:"/"},t.defaults,i),"number"==typeof i.expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}return r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)),n=n.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),n=n.replace(/[\(\)]/g,escape),document.cookie=[n,"=",r,i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],s=/(%[0-9A-Z]{2})+/g,d=0;d<p.length;d++){var f=p[d].split("="),u=f.slice(1).join("=");'"'===u.charAt(0)&&(u=u.slice(1,-1));try{var l=f[0].replace(s,decodeURIComponent);if(u=o.read?o.read(u,l):o(u,l)||u.replace(s,decodeURIComponent),this.json)try{u=JSON.parse(u)}catch(e){}if(n===l){c=u;break}n||(c[l]=u)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}return n(function(){})});if (typeof Cookies !== 'undefined') {
    SECOMAPP.ca.Cookies = Cookies.noConflict();
}

SECOMAPP.ca.Cookie = SECOMAPP.ca.Cookie || {
    name: 'scm_customer_attribute_app',
    count: 'scm_customer_attribute_count',
    setInstalled: function() {
        SECOMAPP.ca.Cookies.set(this.count, 0);
        SECOMAPP.ca.Cookies.set(this.name, "installed");
    },
    isInstalled: function() {
        var count = SECOMAPP.ca.Cookies.get(this.count);
        if (! count) count = 0;
        count++;
        SECOMAPP.ca.Cookies.set(this.count, count);

                    return SECOMAPP.ca.Cookies.get(this.name) === "installed" && count < 3;
            }
};

SECOMAPP.ca.performanceNow = SECOMAPP.ca.performanceNow || function() {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        return Math.round(performance.now()) + ' ms ';
    } else {
        return '';
    }
};

    var scripts = document.head.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; ++i) {
        if(scripts[i].innerText.indexOf('asyncLoad') >= 0 && scripts[i].innerText.indexOf("d2ap73ee6xnmpb.cloudfront.net\\/scripts") >= 0) {
            console.log('already has scripttag, load CA');
            SECOMAPP.ca.installed = true;
        }
    }
    if (! SECOMAPP.ca.Cookie.isInstalled()) {
        SECOMAPP.ca.installed = false;
        console.log(SECOMAPP.ca.performanceNow() + 'preload skip');
    } else {
        SECOMAPP.ca.installed = true;
    }

SECOMAPP.ca.jqVersion = SECOMAPP.ca.jqVersion || function(jQuery) {
    return jQuery.fn.jquery.replace(/\.(\d)/g,".0$1").replace(/\.0(\d{2})/g,".$1");
};

if (SECOMAPP.ca.loadingApp !== true && SECOMAPP.ca.installed === true) {
    SECOMAPP.ca.loadingApp = true;

    SECOMAPP.ca.loadScript = SECOMAPP.ca.loadScript || function(url, callback){
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (script.readyState){  // IE
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {  // Others
            script.onreadystatechange = callback;
            script.onload = callback;
        }

        script.src = url;
        var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(script, x);
    };

    SECOMAPP.ca.loadStyle = SECOMAPP.ca.loadStyle || function(url){
        var head = document.getElementsByTagName("head")[0];
        var extension = '.css';
        var link = document.createElement("link");
        link.href = url;
        link.type = "text/css";
        link.rel = "stylesheet";
        head.appendChild(link);
    };

    SECOMAPP.ca.startCustomerAttribute = SECOMAPP.ca.startCustomerAttribute || function(jQuery) {
        console.log(SECOMAPP.ca.performanceNow() + 'customer attribute app starting...');

            SECOMAPP.updateMultiSelect = function(name) {
    var checkedCheckboxs = jQuery('.ca-multiselect :checkbox[name="'+name+'"]:checked');
    var val = "";
    checkedCheckboxs.each(function(index, checkbox) {
        if (index > 0) val += "|";
        val += jQuery(checkbox).data('value');
    });
    checkedCheckboxs.val(val);
};

if (SECOMAPP.page == 'cart' ) {
    // Shipping field
    function changUrlFormCart(url,param_name,value_param){
        let text_test= "https://test";
        let url_test= text_test+url;
        var url = new URL(url_test);
        var search_params = url.searchParams;
        search_params.set(param_name,value_param);
        url.search = search_params.toString();
        var new_url = url.toString();
        new_url= new_url.replace(text_test,'');
        return new_url;
    }

    jQuery('.ca-cart .ca-value').filter('[data-valueshiping]').each(function() {
        $(this).change(function(){
            let cartForm= $(this).closest('form');
            let url= cartForm.attr('action');
            url= changUrlFormCart(url,$(this).attr('data-valueshiping'),$(this).val());
            console.log(`url sau khi thay doi: ${url}`);
            console.log(this.tagName);
            cartForm.attr('action',url);
        });
    });
    var cartValidate = function() {
        var formIsValid = true;
        var message = "Please fill this out and you will be able to check out.";
        jQuery('[name^="attributes"], [name="note"], input.ca-file').filter('.required, [required="required"], [required]').each(function() {
            jQuery(this).removeClass('error');
            var isEmpty = false;
            if (jQuery(this).hasClass('ca-option')) {
                var name = jQuery(this).attr('name');
                isEmpty = jQuery('[name="'+name+'"]:checked').length == 0;
            } else {
                isEmpty = jQuery(this).val() == '';
            }
            if (isEmpty) {
                formIsValid = false;
                jQuery(this).addClass('error');
                var id = jQuery(this).attr('id');
                jQuery('label[for="'+id+'"]').addClass('error');
            }
        });

        // validate text field by validation rule
        jQuery('input[name^="attributes"]').filter('[data-ca-validate]').each(function() {
            if(jQuery(this).attr('data-ca-validate')) {
                var regex = RegExp(jQuery(this).attr('data-ca-validate'));
                if(!regex.test(jQuery(this).val())) {
                    formIsValid = false;
                    jQuery(this).addClass('error');
                    var id = jQuery(this).attr('id');
                    jQuery('label[for="'+id+'"]').addClass('error');
                    message += '\n' + jQuery(this).attr('data-ca-validate-message');
                }
            }
        });

        if (!formIsValid) {
            if(jQuery('.ca-errors').length > 0) {
                jQuery('.ca-errors').show();
            } else {
                alert(message);
            }
        }

        return formIsValid;
    };
    var cartSubmitFunction = function(event) {
        var formIsValid = cartValidate();

        if (formIsValid){
            jQuery(this).submit();
        } else {
            event.stopImmediatePropagation();
            return false;
        }
    };

    SECOMAPP.ca.cartValidate = cartValidate;

    if (SECOMAPP.ca.jqVersion(jQuery) >= '1.07.00') {
        jQuery('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"], .checkout-button', cartSubmitFunction);
    } else {
        jQuery('body [name="checkout"], body [name="goto_pp"], body [name="goto_gc"], body .checkout-button').bind('click', cartSubmitFunction);
    }

    jQuery('[name^="attributes"], [name="note"]').filter('.required, [required="required"], [required]').focus(function() {
        var id = jQuery(this).attr('id');
        jQuery('label[for="'+id+'"]').removeClass('error');
        jQuery(this).removeClass('error');
    });
}

if (SECOMAPP.page == 'register' ) {
    var registerSubmitFunction = function(event) {
        var formIsValid = true;
        var message = "Please fill the missing fields to continue";
        jQuery('form[action="/account"] [name^="customer[note]"]').filter('.required, [required="required"], [required]').each(function() {
            jQuery(this).removeClass('error');
            var isEmpty = false;
            if (jQuery(this).hasClass('ca-option')) {
                var name = jQuery(this).attr('name');
                isEmpty = jQuery('[name="'+name+'"]:checked').length == 0;
            } else {
                isEmpty = jQuery(this).val() == '';
            }
            if (isEmpty) {
                formIsValid = false;
                jQuery(this).addClass('error');
                var name = jQuery(this).attr('name');
                var last = name.length - 1;
                if (name.substr(-2) === '[]') {
                    last = last - 2;
                }
                var id = name.substring(15, last);
                jQuery('label[for="'+id+'"]').addClass('error');
            }
        });

        // validate text field by validation rule
        jQuery('input[name^="customer"]').filter('[data-ca-validate]').each(function() {
            if(jQuery(this).attr('data-ca-validate')) {
                var regex = RegExp(jQuery(this).attr('data-ca-validate'));
                if(!regex.test(jQuery(this).val())) {
                    formIsValid = false;
                    jQuery(this).addClass('error');
                    var name = jQuery(this).attr('name');
                    var last = name.length - 1;
                    if (name.substr(-2) === '[]') {
                        last = last - 2;
                    }
                    var id = name.substring(15, last);
                    jQuery('label[for="'+id+'"]').addClass('error');
                    message += '\n' + jQuery(this).attr('data-ca-validate-message');
                }
            }
        });

        if (formIsValid){
            jQuery(this).submit();
        } else {
            if(jQuery('.ca-errors').length > 0) {
                jQuery('.ca-errors').show();
            } else {
                alert(message);
            }
            event.stopImmediatePropagation();
            return false;
        }
    };
    if (SECOMAPP.ca.jqVersion(jQuery) >= '1.07.00') {
        if(jQuery('input[name^="customer"]').filter('[data-ca-validate], .required, [required="required"], [required]').length > 0) {
            jQuery('form[action="/account"]').on('click', '[type="submit"]', registerSubmitFunction);
        }
    } else {
        if(jQuery('input[name^="customer"]').filter('[data-ca-validate], .required, [required="required"], [required]').length > 0) {
            jQuery('form[action="/account"] [type="submit"]').bind('click', registerSubmitFunction);
        }
    }
}

if (SECOMAPP.page == 'account' ) {
    var accountSubmitFunction = function(event) {
        var formIsValid = true;
        var message = "Please fill this out and you will be able to check out.";
        jQuery('form#account-form').filter('.required, [required="required"], [required]').each(function() {
            jQuery(this).removeClass('error');
            var isEmpty = false;
            if (jQuery(this).hasClass('ca-option')) {
                var name = jQuery(this).attr('name');
                isEmpty = jQuery('[name="'+name+'"]:checked').length == 0;
            } else {
                isEmpty = jQuery(this).val() == '';
            }
            if (isEmpty) {
                formIsValid = false;
                jQuery(this).addClass('error');
                var id = jQuery(this).attr('id');
                jQuery('label[for="'+id+'"]').addClass('error');
            }
        });

        // validate text field by validation rule
        jQuery('form#account-form [data-ca-validate]').each(function() {
            if(jQuery(this).attr('data-ca-validate')) {
                var regex = RegExp(jQuery(this).attr('data-ca-validate'));
                if(!regex.test(jQuery(this).val())) {
                    formIsValid = false;
                    jQuery(this).addClass('error');
                    var id = jQuery(this).attr('id');
                    jQuery('label[for="'+id+'"]').addClass('error');
                    message += '\n' + jQuery(this).attr('data-ca-validate-message');
                }
            }
        });

        if (formIsValid){
            jQuery(this).submit();
        } else {
            if(jQuery('.ca-errors').length > 0) {
                jQuery('.ca-errors').show();
            } else {
                alert(message);
            }
            event.stopImmediatePropagation();
            return false;
        }
    };

    if (SECOMAPP.ca.jqVersion(jQuery) >= '1.07.00') {
        jQuery('body').on('click', 'form#account-form [type="submit"]', accountSubmitFunction);
    } else {
        jQuery('body form#account-form [type="submit"]').bind('click', accountSubmitFunction);
    }

    jQuery('[name^="attributes"], [name="note"]').filter('.required, [required="required"], [required]').focus(function() {
        var id = jQuery(this).attr('id');
        jQuery('label[for="'+id+'"]').removeClass('error');
        jQuery(this).removeClass('error');
    });
}

if (SECOMAPP.page == 'cart' || SECOMAPP.page == 'register' || SECOMAPP.page == 'account') {
    jQuery('.ca-multiselect:has(":checkbox[required]")').each(function(index, select){
        var requiredCheckboxes = jQuery(':checkbox[required]', select);
        if(requiredCheckboxes.is(':checked')) {
            requiredCheckboxes.removeAttr('required');
        } else {
            requiredCheckboxes.attr('required', 'required');
        }
        requiredCheckboxes.change(function(){
            if(requiredCheckboxes.is(':checked')) {
                requiredCheckboxes.removeAttr('required');
            } else {
                requiredCheckboxes.attr('required', 'required');
            }
        });
    });
}

// relations
SECOMAPP.ca.array_diff = SECOMAPP.ca.array_diff || function (a1, a2) {
    var a = [], diff = [];

    for (var i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
    }

    for (var j = 0; j < a2.length; j++) {
        if (a[a2[j]]) {
            delete a[a2[j]];
        }
    }

    for (var k in a) {
        diff.push(k);
    }

    return diff;
};

SECOMAPP.ca.changeAttributes = SECOMAPP.ca.changeAttributes || function (previousValue, selectedValue, optionsToCodes) {
    var hideCodes = [];
    if (previousValue) {
        hideCodes = optionsToCodes[previousValue] || [];
    }
    var showCodes = [];
    if (selectedValue) {
        showCodes = optionsToCodes[selectedValue] || [];
    }

    var newHideCodes = SECOMAPP.ca.array_diff(hideCodes, showCodes);
    var newShowCodes = SECOMAPP.ca.array_diff(showCodes, hideCodes);

    if (newHideCodes.length > 0) {
        var i;
        for(i = 0; i < newHideCodes.length; i++) {
            SECOMAPP.ca.hideAttribute(newHideCodes[i]);
        }
    }
    if (newShowCodes.length > 0) {
        var i;
        for(i = 0; i < newShowCodes.length; i++) {
            SECOMAPP.ca.showAttribute(newShowCodes[i]);
        }
    }
};

SECOMAPP.ca.showAttribute = SECOMAPP.ca.showAttribute || function (code) {
    if(!jQuery('.ca-child.ca-code-' + code).hasClass('ca-child-show')){
        jQuery('.ca-child.ca-code-' + code).addClass('ca-child-show');
        var elem = jQuery('.ca-value.ca-child.ca-code-' + code);
        elem.attr('name', elem.attr('name_child'));
        elem.removeAttr('name_child');
        elem.removeAttr('disabled');

        jQuery('.ca-select.ca-child.ca-code-' + code + ' .ca-option').each(function() {
            var elem = $(this);
            elem.attr('name', elem.attr('name_child'));
            elem.removeAttr('name_child');
            elem.removeAttr('disabled');
        });
        jQuery('.ca-child.ca-code-' + code).trigger("nested:show");
    }
};

SECOMAPP.ca.hideAttribute = SECOMAPP.ca.hideAttribute || function (code) {
    jQuery('.ca-child.ca-code-' + code).trigger("nested:hide");
    if(jQuery('.ca-child.ca-code-' + code).hasClass('ca-child-show')) {
        jQuery('.ca-child.ca-code-' + code).removeClass('ca-child-show');
        var elem = jQuery('.ca-value.ca-child.ca-code-' + code);
        elem.attr('name_child', elem.attr('name'));
        elem.removeAttr('name');
        elem.attr('disabled', 'disabled');

        jQuery('.ca-select.ca-child.ca-code-' + code + ' .ca-option').each(function() {
            var elem = $(this);
            elem.attr('name_child', elem.attr('name'));
            elem.removeAttr('name');
            elem.attr('disabled', 'disabled');
        });
    }
};
var allOptionsToCodes = {};
    // write map of options => codes to JS object
    var optionsToCodes = {
                    'yes': ['',''],
            };
    allOptionsToCodes['add-candles'] = optionsToCodes;
     // checkbox yes/no
            jQuery('.ca-checkbox.ca-code-add-candles:checkbox').each(function() {
                var checked = jQuery(this).is(":checked:enabled") ? "yes" : "no";
                SECOMAPP.ca.changeAttributes(false, checked, allOptionsToCodes['add-candles']);
            });

            jQuery('.ca-checkbox.ca-code-add-candles:checkbox').on("nested:hide",function () {
                var checked = jQuery(this).is(":checked") ? "yes" : "no";
                var childCodes= allOptionsToCodes['add-candles'][checked] || [];
                var i;
                for( i=0; i < childCodes.length; i++ ){
                    SECOMAPP.ca.hideAttribute(childCodes[i]);
                }
            });
            jQuery('.ca-checkbox.ca-code-add-candles:checkbox').on("nested:show",function () {
                var checked = jQuery(this).is(":checked") ? "yes" : "no";
                var childCodes= allOptionsToCodes['add-candles'][checked] || [];
                var i;
                for( i=0; i < childCodes.length; i++ ){
                    SECOMAPP.ca.showAttribute(childCodes[i]);
                }
            });
            jQuery('.ca-checkbox.ca-code-add-candles:checkbox').change(function () {
                checked = jQuery(this).is(":checked");
                if (checked) {
                    SECOMAPP.ca.changeAttributes('no', 'yes', allOptionsToCodes['add-candles']);
                } else {
                    SECOMAPP.ca.changeAttributes('yes', 'no', allOptionsToCodes['add-candles']);
                }
            });
            
if (SECOMAPP.page == 'cart' || SECOMAPP.page == 'register' || SECOMAPP.page == 'account') {
    
        }
    
            jQuery('.ca-cart:not(.ca-errors), .ca-register, .ca-account').removeClass('ca-hide').show();
        console.log(SECOMAPP.ca.performanceNow() + 'customer attribute app loaded');
        }; // end of SECOMAPP.ca.startCustomerAttributes

    console.log(SECOMAPP.ca.performanceNow() + 'customer attribute script loaded');

    if (SECOMAPP.ca.loadedJs === true) {
        SECOMAPP.ca.startCustomerAttribute(SECOMAPP.jQuery);
    } else {
        if ((typeof $ !== 'undefined') && SECOMAPP.ca.jqVersion($) >= "1.02.06" ) {
            SECOMAPP.jQuery = $;
            $(document).ready(function() {
                if (typeof $ !== 'undefined') {
                    SECOMAPP.jQuery = $;
                }
                try {
                    SECOMAPP.ca.startCustomerAttribute(SECOMAPP.jQuery);
                } catch (err) {
                    console.log(err);
                    console.log(SECOMAPP.ca.performanceNow() + 'customer attribute failed to start, please contact us support@secomapp.com');
                }
            });
        } else if ((typeof jQuery !== 'undefined') && SECOMAPP.ca.jqVersion(jQuery) >= "1.02.06" ) {
            SECOMAPP.jQuery = jQuery;
            jQuery(document).ready(function() {
                if (typeof jQuery !== 'undefined') {
                    SECOMAPP.jQuery = jQuery;
                }
                try {
                    SECOMAPP.ca.startCustomerAttribute(SECOMAPP.jQuery);
                } catch (err) {
                    console.log(err);
                    console.log(SECOMAPP.ca.performanceNow() + 'customer attribute failed to start, please contact us support@secomapp.com');
                }
            });
        } else {
            SECOMAPP.ca.loadScript('//code.jquery.com/jquery-1.11.1.min.js', function() {
                SECOMAPP.jQuery = jQuery.noConflict();
                SECOMAPP.jQuery(document).ready(function() {
                    try {
                        SECOMAPP.ca.startCustomerAttribute(SECOMAPP.jQuery);
                    } catch (err) {
                        console.log(err);
                        console.log(SECOMAPP.ca.performanceNow() + 'customer attribute failed to start, please contact us support@secomapp.com');
                    }
                });
            });
        }
    }

} else {
    console.log(SECOMAPP.ca.performanceNow() + 'skip');
}
